module.exports = __webpack_public_path__ + "static/media/santa-reliquia-slider-1450.64f45f41.jpg";